const fieldValidation = {
  required: '{{fieldName}} 是必須的',
  pattern: '{{fieldName}} is invalid',
};

export default fieldValidation;
